import { TextField } from "@mui/material";
import React, { useEffect, useState } from "react";


export type SampleTextFieldNumberProps = ({
  value: number | string;
  min: number;
  step: number,
  onChangeValue: (value: number) => void
});

const SampleTextFieldNumber: React.FC<SampleTextFieldNumberProps> = ({
  value,
  min = 0,
  step = 1,
  onChangeValue
}) =>
 {
  
   // Estado interno para manejar el valor temporal en el input
   const [inputValue, setInputValue] = useState(value.toString());

   useEffect(() => {
     // Sincroniza el valor de entrada cuando cambia el valor
     setInputValue(value.toString());
   }, [value]);

 const handleChange = (e: React.ChangeEvent<HTMLInputElement>) =>{
  const rawValue = e.target.value.replace(/^0+(?=\d)/, '');
  const numericValue = rawValue ? Number(rawValue) : 0;
  onChangeValue(numericValue)
 }
  //const nuevoValor = e.target.value;

 return (
  <TextField
    variant="outlined"
    type={'number'}
 
    //value={value}
    value={inputValue}
    inputProps={{ min, step }}
    //onChange={(e) => onChangeValue((+e.target.value))}
    onChange={handleChange}
    
    onKeyDown={(e) => {
      if (['e', 'E', '-', '.', ',', ';', '/', '*', '+', '{', '[', '""', '¨¨', '_'].includes(e.key)) {
        e.preventDefault();
      }
    }}

  />

)}

export default SampleTextFieldNumber
